import React from 'react'

export const ServiciosComponent = () => {
    return (
        <div className='page'>
            <h1 className='heading'>Mis Servicios Especializados</h1>

            <section className='services'>
                <article className='service fullstack'>
                    <div className="service-icon">🚀</div>
                    <h2>Desarrollo Full Stack</h2>
                    <p>Creación de aplicaciones web completas de principio a fin. Utilizando el stack MERN (MongoDB, Express, React, Node.js) y Next.js para soluciones robustas y escalables.</p>
                </article>

                <article className='service scraping'>
                    <div className="service-icon">🔍</div>
                    <h2>Web Scraping y Automatización</h2>
                    <p>Extracción inteligente de datos y automatización de procesos web. Experiencia en recolección de valores de divisas y datos complejos para análisis de mercado.</p>
                </article>

                <article className='service cloud'>
                    <div className="service-icon">☁️</div>
                    <h2>Arquitectura Cloud y DevOps</h2>
                    <p>Implementación y despliegue en infraestructuras modernas como AWS (S3, Cognito), Hostinger y Render. Configuración de entornos de desarrollo, QA y producción.</p>
                </article>

                <article className='service security'>
                    <div className="service-icon">🔐</div>
                    <h2>Seguridad y Autenticación</h2>
                    <p>Implementación de sistemas de seguridad robustos mediante JWT (JSON Web Tokens) y AWS Cognito, asegurando la integridad y privacidad de los datos de tus usuarios.</p>
                </article>

                <article className='service frontend'>
                    <div className="service-icon">🎨</div>
                    <h2>Frontend Moderno y UI/UX</h2>
                    <p>Diseño de interfaces modernas, responsivas y altamente interactivas usando TypeScript, Tailwind CSS y animaciones fluidas para una experiencia de usuario superior.</p>
                </article>

                <article className='service cloud'>
                    <div className="service-icon">📊</div>
                    <h2>Bases de Datos y Backend</h2>
                    <p>Diseño de estructuras de datos eficientes tanto en SQL (MySQL, Postgres) como NoSQL (MongoDB), integradas con APIs RESTful de alto rendimiento.</p>
                </article>
            </section>
        </div>
    )
}
